import { formatPatientTitle } from '@app/icare/entities/patient/config'
import type { Patient } from '@app/icare/entities/patient/schema/Patient'
import { mergeNonEmptyStrings } from '@pkg/shared/utils'
import { twMerge } from 'tailwind-merge'

interface PatientLike {
  personal?: Partial<Patient['personal']> | null
  address?: Partial<Patient['address']> | null
}

interface PatientTitleProps {
  value?: PatientLike | null
  className?: string
  showAddress?: boolean
}

// Re-export formatPatientTitle for backwards compatibility
export { formatPatientTitle } from '@app/icare/entities/patient/config'

const PatientTitle = (props: PatientTitleProps) => {
  const { value, showAddress, className } = props

  return (
    <div className={twMerge([showAddress && 'flex flex-col', className])}>
      <span>{formatPatientTitle(value)}</span>
      {showAddress && (
        <>
          <span>{value?.address?.streetAddress}</span>
          <span>{mergeNonEmptyStrings([value?.address?.zipCode, value?.address?.city])}</span>
        </>
      )}
    </div>
  )
}

export default PatientTitle
